import useSWR from "swr";

import * as fetcher from "../fetcher";
import { type CommunicationHistory } from "./types";

export interface CommunicationEmailResponse {
  to: string[];
  cc: string[];
  subject: string;
  body: string;
}

export const useCommunicationHistory = (projectId?: number) => {
  return useSWR<CommunicationHistory[]>(
    projectId ? `/communication/${projectId}/email` : null,
    () => fetcher.opportunity.get(`/communication/${projectId}/email`),
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
    }
  );
};
